// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"8ad9d2fb","453":"9ae9ca0f","605":"fbc4ffc0","670":"aed802a6","944":"2aa5edab"}[chunkId] + ".chunk.js";
};